<script>
import navegacion from './elements/Navegacion.vue'
import bannersQuicktable from '../Nextbanners/NextbannersMainCard.vue'
export default {
    name: 'CatalogosBannersInApp',
    components: { navegacion, bannersQuicktable },
    methods: {
        catLoaded() {
            if (!!this.$refs && !!this.$refs.nutricionales) {
                this.$refs.nutricionales.refresh()
            }
        }
    }
}
</script>

<template>
    <div id="CatalogosBannersInApp">
        <navegacion class="mb-4"/>
        <banners-quicktable />
    </div>
</template>